// Pure tracker URL defaults and presets (architecture sprint-05 §6.3). Default: this week up to today
// (the Admin's zone). Last week is the full previous Mon–Sun.
import { addDays, weekRange, type LocalDate } from '@shared/calendar';
import type { DateRange } from '@/lib/report-model';
import { formatShortLocalDate } from '@/lib/format';

const DAYS_PER_WEEK = 7;

export type TrackerPresetKey = 'this-week' | 'last-week';

export const TRACKER_PRESET_LABELS: Array<{ key: TrackerPresetKey; label: string }> = [
  { key: 'this-week', label: 'This week' },
  { key: 'last-week', label: 'Last week' },
];

export function trackerPresetRange(key: TrackerPresetKey, today: LocalDate): DateRange {
  if (key === 'this-week') return { from: weekRange(today).start, to: today };
  const w = weekRange(addDays(today, -DAYS_PER_WEEK));
  return { from: w.start, to: w.end };
}

export function defaultTrackerRange(today: LocalDate): DateRange {
  return trackerPresetRange('this-week', today);
}

/** Column header: 'Mon 5 Oct'. */
export function trackerColumnLabel(date: LocalDate): string {
  return formatShortLocalDate(date);
}

/** Records deep link for one user and one day (cell click-through); sprint 11: optionally one project. */
export function recordsLinkFor(userId: string, date: LocalDate, projectId?: string): string {
  const q = new URLSearchParams({ from: date, to: date, user: userId });
  if (projectId) q.set('project', projectId);
  return `/admin/records?${q.toString()}`;
}

/** Sprint 11 (§9.3): the Supervisor-facing records page for one project, user and day. */
export function oversightRecordsLinkFor(projectId: string, userId: string, date: LocalDate): string {
  return `/oversight/records?${new URLSearchParams({ project: projectId, from: date, to: date, user: userId }).toString()}`;
}
